import { request as axiosRequest } from '../axios';
import { createApiFoctory } from './createApiFoctory';

export { createApiFoctory };

export const axiosApi = createApiFoctory(axiosRequest);
